export default __webpack_public_path__ + "static/media/avatar_140.2777f505.png";